<h2 mat-dialog-title>Detalle de Movimientos de Consolidado de Caja</h2>

<div mat-dialog-content>

  <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="!isSearching">

      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Concepto</b>: {{input?.SelectedRow?.Concepto ? input?.SelectedRow?.Concepto : input?.SelectedRow?.ComunidadNombre }}</mat-label>
            </div>
          </mat-expansion-panel>
      </div>
      <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label>
                <b>Balance Neto{{esMonedaConversion ? ' (convertido)' : ''}}</b>:
                <span style="margin-left: 5px;" [ngStyle]="{ color: (input?.SelectedRow?.Neto >= 0) ? 'black' : 'indianred' }">{{input?.SelectedRow?.Moneda}} {{input?.SelectedRow?.Neto | number:'1.2-2'}}</span>
              </mat-label>
            </div>
          </mat-expansion-panel>
      </div>

  </div>

  <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">

      <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
        [pageSettings]='pageSettings' [allowResizing]='true' [enableKeyboardNavigation]="false" (mousedown)="onClickRow($event)" (rowSelecting)="rowSelecting($event)"
        (contextMenuClick)='contextMenuClick($event)' [contextMenuItems]='contextMenuItems' (contextMenuOpen)='contextMenuOpen($event)'>
        <e-columns>
          <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=90 type='date' format="dd/MM/yyyy"></e-column>
          <e-column field='CuentaImputadaCodigo' headerText='Cuenta' width=90></e-column>
          <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
          <e-column field='Detalle' headerText='Detalle' width=100></e-column>
          <e-column field='Estado' headerText='Estado' width=100></e-column>
          <e-column field='MedioPago' headerText='Medio de Pago' width=90></e-column>
          <e-column field='Moneda' headerText='Moneda' width=50></e-column>
          <e-column field='Monto' headerText='Monto' textAlign="right" width=70 format="N2"></e-column>
          <e-column field='FechaVencimiento' headerText='Vencimiento' width=90 type='date' format="dd/MM/yyyy"></e-column>
        </e-columns>
      </ejs-grid>

  </div>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="warn" (click)="onAccept()" class="zb-button">Cerrar</button>
    <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="primary" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar Detalle'}}</button>
  </div>
</div>